module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_feature_2-6d18580f2336c2993e9d2324bf963d31.jpg";